//
//
//
//
//
//
//
//
//
//
//
//

import SearchItemDropdown from '@/components/search/SearchItemDropdown'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'CategoriesDropdown',
  components: {
    SearchItemDropdown
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    category: {
      type: Number,
      default: null
    }
  },
  computed: {
    /**
     * Array of categories
     * @returns {any[]}
     */
    categories () {
      return this.$store.getters['util/getCategoriesByName']
    },
    selectedCategoryName () {
      return this.categories.find(c => c.id === this.category)?.name
    }
  },
  methods: {
    selectCategory (c) {
      this.$emit('select', c.id)
    },

    removeCategory () {
      this.$emit('select', null)
    }
  }
}
